<script>
import appConfig from "@/app.config";
export default {
  props: {
    data: {
      type: Object,
      // default() {
      //   return "";
      // },
    },
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
    }
  },
  watch: { 
    data: function() { // watch it

    }
  },
}
</script>
<template>
  <div :class="$style.whiteCard" class="d-inline-block w-100 rounded-14">
    <div class="d-flex flex-row  ">
      <div :class="$style.logo">
        <img :src="assetsPath + 'images/'+ data.logo" />
      </div>
      <div :class="$style.content">
        <h3>{{data.title}}</h3>
        <p>{{data.description}}</p>
      </div>
    </div>
    <a :href="GLOBAL.hrefLink(data.link)" class="btn btn-info btn-lg rounded-half w-100">
      {{data.more}}
    </a>
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";
.whiteCard {
  background-color: $white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  padding: 22px 24px 24px;
  text-align: left;
  .logo {
    min-width: 72px;
    margin-right: 20px;
    max-width: 72px;
  }
  h3 {
    font-family: $family-bold;
    font-size: 18px;
    margin-bottom: 8px;
  }
  p {
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 21px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
